'use client'

import { useTranslate } from '@marketplace-web/shared/i18n'
import { PricingRuleModel } from '@marketplace-web/domain/escrow-pricing-data'
import { CountryModel } from '@marketplace-web/domain/country-data'
import { CatalogNavigationModel } from '@marketplace-web/domain/catalog-data'

import usePricingRuleDataFormatter from '../hooks/use-pricing-rule-data-formatter'
import PriceRuleTitle from './PricingRuleTitle'
import PriceRuleDataRow from './PriceRuleDataRow'
import TargetedCampaignNote from './TargetedCampaignNote'
import FactGroupList from './FactGroupList'

type Props = {
  priceRule: PricingRuleModel
  countries?: Array<CountryModel> | null
  catalogs: Array<CatalogNavigationModel>
}

const PriceRuleSection = ({ priceRule, countries, catalogs }: Props) => {
  const translate = useTranslate('available_discounts')
  const priceRuleData = usePricingRuleDataFormatter({ priceRule, countries, catalogs })

  return (
    <section className="available_discounts__price-rule-section">
      <PriceRuleTitle priceRule={priceRule} />
      <TargetedCampaignNote priceRule={priceRule} />
      <div className="available_discounts__price-rule-card">
        <div>
          <h3 className="available_discounts__pricing-rule-card-title">
            {translate('discount_terms_label')}
          </h3>
          {priceRuleData.map(ruleDataRow => (
            <PriceRuleDataRow key={ruleDataRow.label} ruleDataRow={ruleDataRow} />
          ))}
        </div>
        <FactGroupList priceRule={priceRule} countries={countries} catalogs={catalogs} />
      </div>
    </section>
  )
}

export default PriceRuleSection
